import Vue from 'vue'
import Utils from '../../utils/utils'

export function getDispatchWhiteList () {
  return Vue.http.get(Utils.paths.PDTree.getDispatchWhiteList, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}

export function changeDispatchWhiteList (PDCODE, pdFruDescription, enabled) {
  return Vue.http.get(Utils.paths.PDTree.changeDispatchWhiteList + '?PDCODE=' + PDCODE + '&pd_fru_description=' + pdFruDescription + '&enabled=' + enabled, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}

export function getClass2CCList () {
  return Vue.http.get(Utils.paths.PDTree.getClass2CCList, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}

export function getGuidChain (MT) {
  return fetch(Utils.paths.ProductInfo.getGuidChain + '?MT=' + MT, {method: 'get', headers: {'content-type': 'application/json'}})
}

export function getFRUList (MTM, SN, FRUView) {
  return Vue.http.get(Utils.paths.PDTree.getFRUList + '?MTM=' + MTM + '&SN=' + SN + '&type=' + FRUView, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}

export function querySymptomByType (type, region) {
  return Vue.http.get(Utils.paths.PDTree.querySymptomByType + '?product=' + type + '&region=' + region, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryTop10Symptom (type, region) {
  return Vue.http.get(Utils.paths.PDTree.queryTop10Symptom + '?product=' + type + '&region=' + region, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryCommonPDSeq (COMMONPDCODE) {
  return Vue.http.get(Utils.paths.PDTree.queryCommonPDSeq + '?COMMONPDCODE=' + COMMONPDCODE, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function querySolutionSeq (type) {
  return Vue.http.get(Utils.paths.PDTree.querySolutionSeq + '?SolutionCode=' + type, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function commonPDDump () {
  return Vue.http.get(Utils.paths.PDTree.commonPDDump, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function solutionDump () {
  return Vue.http.get(Utils.paths.PDTree.solutionDump, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryLangProps (lang) {
  return Vue.http.get(Utils.paths.PDTree.queryLangProps + '?lang=' + lang, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function FRCValidate (param) {
  return Vue.http.get(Utils.paths.PDTree.FRCValidate + '?paramSN=' + param.serialNo + '&paramDS=' + param.date + '&paramFRC=' + param.resCodeP1 + '-' + param.resCodeP2, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function UploadPDTreeServlet (param) {
  // let queryStr = ''
  // for (let i in Object.keys(param)) {
  //   let key = Object.keys(param)[i]
  //   let val = param[key]
  //   queryStr += key + '=' + val
  //   if (i < (Object.keys(param).length - 1)) {
  //     queryStr += '&'
  //   }
  // }
  return Vue.http.post(Utils.paths.GAE.UploadPDTreeServlet, param, {emulateJSON: true})
}
export function UploadRC2Servlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadRC2Servlet, param, {emulateJSON: true})
}
export function NLPPredict (param, type) {
  let url = ''
  if (type === 2) {
    url = Utils.paths.NLPPredict2
  } else {
    url = Utils.paths.NLPPredict1
  }
  return Vue.http.post(url, param, {emulateJSON: false})
}
export function NLPMultiLang (param) {
  return Vue.http.post(Utils.paths.PDTree.NLPMultiLang, param, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function UploadTipsServlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadTipsServlet, param, {emulateJSON: true})
}
export function UploadAISearchServlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadAISearchServlet, param, {emulateJSON: true})
}
export function UploadPartsDispatchServlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadPartsDispatchServlet, param, {emulateJSON: true})
}
export function UploadStatPDNewServlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadStatPDNewServlet, param, {emulateJSON: true})
}
export function UploadStatP2Servlet (param) {
  return Vue.http.post(Utils.paths.GAE.UploadStatP2Servlet, param, {emulateJSON: true})
}

export function RetrieveRC2Servlet (SN) {
  return Vue.http.get(Utils.paths.GAE.RetrieveRC2Servlet + '?diSerial=' + SN, {emulateJSON: true})
}

export function POIRequest (para) {
  return Vue.http.post(Utils.paths.POIRequest, para, {headers: {'ContentType': 'application/x-www-form-urlencoded'}})
}

export function translate (para) {
  return Vue.http.post(Utils.paths.translate, para, {headers: {'ContentType': 'application/x-www-form-urlencoded'}})
}



// WEBPACK FOOTER //
// ./src/api/modules/RequestPDTree.js